import {
  useUpdateApplicationStepConfirmationMutation,
  useCancelApplicationMutation,
} from 'src/types/generated'

type ApprovedApplicationRequestInput = {
  applicationId: number
  applicationStepId: number
  comment?: string
  isProxy?: boolean
}
type RejectApplicationRequestInput = {
  applicationId: number
  applicationStepId: number
  comment: string
  isProxy?: boolean
}

type CancelApplicationRequestInput = {
  applicationId: number
  comment?: string
}

export const useApplicationRequest = () => {
  const [updateApplicationStepConfirmationMutation] = useUpdateApplicationStepConfirmationMutation()
  const [cancelApplicationMutation] = useCancelApplicationMutation()

  const approveApplicationRequest = async (input: ApprovedApplicationRequestInput) => {
    await updateApplicationStepConfirmationMutation({
      variables: { input: { ...input, isApproved: true, isProxy: input.isProxy ?? false } },
    })
  }
  const rejectApplicationRequest = async (input: RejectApplicationRequestInput) => {
    await updateApplicationStepConfirmationMutation({
      variables: { input: { ...input, isApproved: false, isProxy: input.isProxy ?? false } },
    })
  }

  const cancelApplicationRequest = async (input: CancelApplicationRequestInput) => {
    const { applicationId, comment } = input
    await cancelApplicationMutation({
      variables: { params: { applicationId, comment } },
    })
  }

  return {
    approveApplicationRequest,
    rejectApplicationRequest,
    cancelApplicationRequest,
  }
}
